"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("./core");
const components_1 = require("@apitable/components");
const dashboard_widget_permission_light_png_1 = __importDefault(require("./static/dashboard_widget_permission_light.png"));
const dashboard_widget_permission_dark_png_1 = __importDefault(require("./static/dashboard_widget_permission_dark.png"));
const ErrorMessage = (props) => {
    const { errorCode, themeName } = props;
    const widgetNoPermission = themeName === components_1.ThemeName.Light ? dashboard_widget_permission_light_png_1.default : dashboard_widget_permission_dark_png_1.default;
    const getErrorTip = () => {
        switch (errorCode) {
            case core_1.StatusCode.NODE_DELETED:
                return (0, core_1.t)(core_1.Strings.widget_datasheet_has_delete);
            case core_1.StatusCode.NODE_NOT_EXIST:
                return (0, core_1.t)(core_1.Strings.widget_no_access_datasheet);
            default:
                return (0, core_1.t)(core_1.Strings.widget_unknow_err, {
                    info: errorCode,
                });
        }
    };
    return (react_1.default.createElement("div", { style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
            width: '100%',
        } },
        react_1.default.createElement("div", { style: {
                width: '160px',
                height: '120px',
                margin: '0 auto',
            } },
            react_1.default.createElement("img", { src: widgetNoPermission.src, alt: '', width: 160, height: 120, style: { margin: '0 auto' } })),
        react_1.default.createElement("p", { style: {
                textAlign: 'center',
                fontSize: 14,
            } },
            getErrorTip(),
            "\uFF0C",
            react_1.default.createElement("a", { href: (0, core_1.t)(core_1.Strings.dashboard_access_denied_help_link), target: "_blank", rel: "noopener noreferrer", style: {
                    borderBottom: '1px solid',
                    paddingBottom: 2,
                } }, (0, core_1.t)(core_1.Strings.know_more)))));
};
exports.ErrorMessage = ErrorMessage;
